import { useEffect, useState } from "react";

type IconProps = {
  className?: string;
  fill?: string;
};

const MatchedIcon = ({ className, fill = "#2e2e2e" }: IconProps) => {
  const [_class, setClass] = useState(className);

  useEffect(() => {
    let classStr = className || "";
    if (!classStr.includes("w-")) {
      classStr += " w-5";
    }
    if (!classStr.includes("h-")) {
      classStr += " h-5";
    }

    setClass(classStr);
  }, [className]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="0"
      stroke={fill}
      className={_class}
    >
      <path
        d="M18.0713 8.00564C17.3482 8.00564 16.7623 8.59185 16.7623 9.31469C16.7623 10.0378 17.3482 10.624 18.0713 10.624C18.7942 10.624 19.3804 10.0378 19.3804 9.31469C19.3804 8.59185 18.7942 8.00564 18.0713 8.00564ZM18.6573 14.8139V19.8775C18.6573 20.2012 18.3948 20.4637 18.0713 20.4637H5.93528C5.61156 20.4637 5.34907 20.2012 5.34907 19.8775V14.8139C2.47302 14.5177 0.28125 12.0856 0.28125 9.19024C0.28125 6.06786 2.81289 3.5365 5.93528 3.5365C9.05767 3.5365 11.589 6.06786 11.589 9.19024C11.589 12.0859 9.39726 14.5177 6.5212 14.8139V19.2913H17.4851V14.8139C14.6091 14.5177 12.4176 12.0856 12.4176 9.19024C12.4176 6.06786 14.949 3.5365 18.0713 3.5365C21.1937 3.5365 23.7251 6.06786 23.7251 9.19024C23.7251 12.0859 21.5333 14.5177 18.6573 14.8139ZM5.93528 6.8335C7.30556 6.8335 8.41646 7.94441 8.41646 9.31497C8.41646 9.84307 8.25149 10.3326 7.97 10.7351C8.52333 11.0963 8.97092 11.5977 9.26573 12.189C9.9812 11.395 10.4169 10.3434 10.4169 9.19024C10.4169 6.71501 8.41023 4.70863 5.93528 4.70863C3.46005 4.70863 1.45339 6.71501 1.45339 9.19024C1.45339 10.3434 1.88907 11.3948 2.60483 12.189C2.89963 11.5977 3.34723 11.0963 3.90027 10.7351C3.61907 10.3326 3.45381 9.84307 3.45381 9.31497C3.45381 7.94441 4.56472 6.8335 5.93528 6.8335ZM7.02549 11.5444C6.69639 11.7054 6.32646 11.7962 5.93528 11.7962C5.5441 11.7962 5.17389 11.7054 4.84478 11.5444C4.241 11.8305 3.76704 12.3495 3.53658 12.9768C4.23023 13.417 5.05285 13.6719 5.93528 13.6719C6.81743 13.6719 7.64033 13.417 8.33369 12.9768C8.10352 12.3498 7.62928 11.8305 7.02549 11.5444ZM5.93528 8.00564C5.21216 8.00564 4.62623 8.59185 4.62623 9.31497C4.62623 10.0381 5.21216 10.624 5.93528 10.624C6.65812 10.624 7.24433 10.0378 7.24433 9.31497C7.24433 8.59185 6.6584 8.00564 5.93528 8.00564ZM18.0713 4.70863C15.5961 4.70863 13.5897 6.71501 13.5897 9.19024C13.5897 10.3434 14.0254 11.395 14.7409 12.189C15.0357 11.5977 15.483 11.0963 16.0363 10.7349C15.7551 10.3326 15.5899 9.84307 15.5899 9.31469C15.5899 7.94441 16.7008 6.8335 18.0713 6.8335C19.4416 6.8335 20.5525 7.94441 20.5525 9.31469C20.5525 9.84307 20.3876 10.3326 20.1061 10.7351C20.6594 11.0966 21.1067 11.5977 21.4015 12.189C22.1173 11.395 22.553 10.3434 22.553 9.19024C22.553 6.71501 20.5463 4.70863 18.0713 4.70863ZM16.9808 11.5444C16.3771 11.8305 15.9031 12.3495 15.6729 12.9768C16.3663 13.417 17.1889 13.6719 18.0713 13.6719C18.9535 13.6719 19.7761 13.417 20.4698 12.9768C20.2396 12.3495 19.7653 11.8305 19.1616 11.5444C18.8325 11.7054 18.4625 11.7962 18.0713 11.7962C17.6802 11.7962 17.31 11.7054 16.9808 11.5444Z"
        fill={fill}
      />
    </svg>
  );
};

export default MatchedIcon;
